import { AssetKey } from '@constants/asset-keys.const';
import { StageInfo } from '@models/game-config.interface';

export function loadThemeAssets(scene: Phaser.Scene, game: StageInfo) {
  // Static bundled assets (dice, UI icons, shadows, decor, etc.)
  scene.load.pack('asset-pack', 'asset-pack.json');

  const { theme } = game;

  // Theme images from game config
  scene.load.image(AssetKey.GameLogo, theme.gameLogoUrl);
  scene.load.image(AssetKey.HomeBg, theme.homePageBackgroundUrl);
  scene.load.image(AssetKey.GameBg, theme.gamePageBackgroundUrl);

  // node textures loaded from URL.
  scene.load.image(
    AssetKey.NodeUpcoming,
    theme.upcomingNodeUrl ?? theme.defaultNodeUrl, // add a fallback
  );
  scene.load.image(AssetKey.NodeCompleted, theme.defaultNodeUrl);
  scene.load.image(
    AssetKey.NodeActionUpcoming,
    theme.actionUpcomingNodeUrl ?? theme.actionNodeUrl, // add a fallback
  );
  scene.load.image(AssetKey.NodeActionCompleted, theme.actionNodeUrl);

  // Action symbols — key is action UUID
  game.actionsConfig?.actions.forEach((action) => {
    scene.load.image(action.uuid, action.symbolUrl);
  });

  // Collectible icons — key is collectible UUID
  game.collectiblesConfig?.collectibles.forEach((collectible) => {
    scene.load.image(collectible.uuid, collectible.iconUrl);
  });

  // Scene Layout assets — deduplicate by URL; multiple assets may share the same image.
  // Texture key = URL so Phaser's own cache check prevents any re-upload on repeated loads.
  const seenLayoutUrls = new Set<string>();
  game.layoutAssets.forEach((asset) => {
    if (!seenLayoutUrls.has(asset.url)) {
      seenLayoutUrls.add(asset.url);
      scene.load.image(asset.url, asset.url);
    }
  });
}
